<template>
  <div class="columns">
    <div class="columns__item">
      <Label :label="columns[0].label" />
      <p v-html="columns[0].text"></p>
    </div>
    <div class="columns__icon">
      <component
        :is="icon"
      />
    </div>
    <div class="columns__item">
      <Label :label="columns[1].label" />
      <p v-html="columns[1].text"></p>
    </div>
  </div>
</template>

<script>
import * as components from '@/icons'
import Label from '@/components/partials/Label.vue'


export default {
  components: {
    ...components,
    Label
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: 'arrow-right'
    }
  }
}
</script>

<style lang="scss">
.columns {
  display: flex;
  padding: $columns-padding;
  border: $columns-border;
  &__item {
    width: 50%;
  }
  &__icon {
    flex-shrink: 0;
    align-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: $columns-button-size;
    height: $columns-button-size;
    background: $columns-button-background;
    border-radius: 50%;
    margin: $columns-button-space-around;
    svg {
      fill: $columns-button-icon-color;
      width: $columns-button-icon-width;
      height: $columns-button-icon-width;
    }
  }
}
</style>


<docs>
  ```vue
  <Columns
    :columns="[{ label: 'now', text: 'Current<br> Location' }, { label: 'hotel', text: 'Warmoesstraat 12A<br> Amsterdam' }]"
    :icon="'arrow-right'"
  />
  ```
  ```scss
  // Variable defaults:
  $columns-padding: rem(30 0);
  $columns-border: 0;
  $columns-button-size: rem(40);
  $columns-button-background: transparent;
  $columns-button-icon-width: rem(16);
  $columns-button-icon-height: $columns-button-icon-width;
  $columns-button-icon-color: color(dark);
  $columns-button-space-around: rem(0 20);
  ```
</docs>
